import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useLang } from "@/context/LanguageContext";
import { ReserveButton, MarketButton } from "@/components/shared";
import { Ornament } from "@/components/Ornament";

// Product detail overlay with WhatsApp reserve + marketplace actions.
export const ProductDialog = ({ item, open, onOpenChange }) => {
  const { t, lang, contact } = useLang();
  if (!item) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl p-0 overflow-hidden bg-espresso border-gold/25 gap-0" data-testid="product-dialog">
        <div className="grid md:grid-cols-2">
          <div className="relative aspect-square md:aspect-auto md:h-full overflow-hidden">
            <img src={item.image} alt={item.name[lang]} className="w-full h-full object-cover" />
            <span className="absolute top-4 left-4 text-[10px] tracking-widest uppercase bg-sage/85 text-cream px-3 py-1 rounded-full">{t.brocken.available}</span>
          </div>
          <div className="p-8 flex flex-col">
            <span className="text-[10px] tracking-[0.3em] uppercase text-gold/80">{item.tag[lang]} · {item.era}</span>
            <DialogTitle className="font-serif text-3xl text-cream mt-2 leading-tight">{item.name[lang]}</DialogTitle>
            <Ornament className="my-5 justify-start opacity-70" width={160} />
            <p className="text-cream/70 font-sans text-sm leading-relaxed">{t.brocken.body}</p>
            <p className="mt-4 text-rose/90 font-sans text-xs leading-snug">{t.fresh.fomo}</p>
            <span className="mt-6 text-gold font-serif text-2xl">{item.price}</span>
            <div className="mt-6 flex flex-col gap-3">
              <ReserveButton phone={contact.whatsapp} name={item.name.de} label={t.cta.reserve} testid={`dialog-reserve-${item.id}`} className="w-full !py-3 !text-sm" />
              <MarketButton url={item.market.url} label={item.market.platform === "ricardo" ? t.cta.ricardo : t.cta.tutti} testid={`dialog-market-${item.id}`} className="w-full !py-3 !text-sm" />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProductDialog;
